export default __webpack_public_path__ + "static/media/left.6691ead3.svg";